import { Inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@personal-area/storage'
import { ComposedReferralData } from '@personal-area/global/users/models';
import { LOCAL_STORAGE } from '@personal-area/storage';
import { REFERRAL_QUERY_PARAMS } from '../constants/referral-query-params';
import { REFERRAL_LINK_PARAMS_STORAGE_KEY, REFERRAL_LINK_TTL_IN_DAYS } from '../constants/storage-keys'
@Injectable({
  providedIn: 'root'
})
export class ReferralStorageService {
  constructor(
    private _localStorageService: LocalStorageService,
    @Inject(LOCAL_STORAGE) private _localStorage: Storage,
  ) { }

  public save(referralData: ComposedReferralData): void {
    this._localStorageService.setItem<ComposedReferralData>(
      REFERRAL_LINK_PARAMS_STORAGE_KEY,
      referralData,
      REFERRAL_LINK_TTL_IN_DAYS,
      this._localStorage)
  }

  public load(): ComposedReferralData | null {
    return this._localStorageService.getItem<ComposedReferralData>(
      REFERRAL_LINK_PARAMS_STORAGE_KEY,
      this._localStorage
    )
  }

  public clearAllReferralDataFromStorage(): void {
    [
      'fbs:ibl',
      'ibl',
      'ibp',
      'ibk',
      'ppu',
      'ppk',
      'fbs:referralLink',
      REFERRAL_LINK_PARAMS_STORAGE_KEY
    ].forEach(storageKey => this._localStorageService.removeItem(storageKey, this._localStorage))
  }

  public migrateLegacyReferralData(): void {
    const oldRefLink = this._localStorageService.getItem<{ value: string }>('fbs:ibl');
    const hasAnyRefData = oldRefLink && [...REFERRAL_QUERY_PARAMS.actual, ...REFERRAL_QUERY_PARAMS.legacy]
      .some(referralKey => Object.keys(oldRefLink).includes(referralKey))
    if (hasAnyRefData) {
      this._localStorageService.setItem<{ ibl: string }>(
        REFERRAL_LINK_PARAMS_STORAGE_KEY,
        { ibl: oldRefLink['value'] },
        REFERRAL_LINK_TTL_IN_DAYS,
        this._localStorage
      );
      this._localStorageService.removeItem('fbs:ibl');
    }
  }
}
